<template lang="html">
  <div class="startup_page" id="content">
    <div class="container content_div">
      <div class="row">
          <h2 class="customH2 tblue text-center">Comparison of innovators</h2>
      <div class="col-12 mt50">
        <vue-collapsible-panel-group base-color="#3783C5">
            <vue-collapsible-panel>
                <template #title>
                        <h2 class="customH2">Data to display</h2>
                </template>
                <template #content>

                        <div class="filtre_list">
                          <div  v-for="(value, key) in fieldDisplaySorted" :key="key">
                              <label class="checkbox">
                                    <input  class="checkbox__input" type="checkbox" v-model="fieldDisplay[key]">
                                  <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                    <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                                    <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                                  </svg>
                                  <span class="checkbox__label">
                                    <span v-if="key == 'ip'">IP</span>
                                    <span v-else-if="key == 'trl'">TRL</span>
                                    <span v-else-if="key == 'skills'">Core capabilities</span>

                                    <span v-else-if="key == 'application_area'">Application domain</span>
                                    <span v-else-if="key == 'product_category'">Innovation category</span>
                                    <span v-else>{{ key.replaceAll("_"," ").charAt(0).toUpperCase() + key.replaceAll("_"," ").slice(1) }}</span>
                                  </span>
                                </label>

                          </div>

                    </div>


                </template>
            </vue-collapsible-panel>
        </vue-collapsible-panel-group>

        <vue3-html2pdf
             :show-layout="false"
             :float-layout="true"
             :enable-download="true"
             :preview-modal="false"
             filename="export"
             :pdf-quality="2"
             pdf-format="a4"
             pdf-orientation="landscape"
             ref="html2Pdf"
             :manual-pagination="true"
             :paginate-elements-by-height="1400"
         >
               <template  v-slot:pdf-content>
                <section style="width:297mm;padding:25px;"  class=" forPDF" :class="{ 'col3' : startupC }">

                <div class="inside">
                <div class="startupA">
                  <div class="startup_compare_header ">

                            <span class="startup_name">{{startupA.name}}</span>
                          </div>
                </div>
                <div class="startupB">
                  <div class="startup_compare_header ">
                    <span  class="startup_name">{{startupB.name}}</span>
                  </div>
                </div>
                <div class="startupC" v-if="startupC">
                  <div class="startup_compare_header ">
                    <span  class="startup_name">{{startupC.name}}</span>
                  </div>
                </div>
              </div>


              <div v-for="(value, key, index) in fieldDisplayOK" :key="key" >
                <div class="html2pdf__page-break" v-if="index % 8 == 0 && index != 0"/>
                <div class="inside"  v-if="index % 8 == 0 && index != 0">
                <div class="startupA">
                  <div class="startup_compare_header ">

                            <span  class="startup_name">{{startupA.name}}</span>
                          </div>
                </div>
                <div class="startupB">
                  <div class="startup_compare_header ">
                    <span  class="startup_name">{{startupB.name}}</span>
                  </div>
                </div>
                <div class="startupC" v-if="startupC">
                  <div class="startup_compare_header ">
                    <span  class="startup_name">{{startupC.name}}</span>
                  </div>
                </div>
              </div>

                <div class="inside">


                  <div class="startupA">
                    <StartupInfoLine  className="noBorder" v-if="startupA[key]" :name="labelize(key)" :value="startupA[key]" :isArray="Array.isArray(startupA[key])" :isCurrency="isCurrencyKey(key)"  :isBoolean="isBooleanKey(key)"/>

                    <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"  :noData="true"/>
                  </div>
                  <div class="startupB">
                    <StartupInfoLine  className="noBorder" v-if="startupB[key]" :name="labelize(key)" :value="startupB[key]" :isArray="Array.isArray(startupB[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>

                    <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"  :noData="true" />
                  </div>
                  <div class="startupC"  v-if="startupC">
                    <StartupInfoLine  className="noBorder" v-if="startupC[key]" :name="labelize(key)" :value="startupC[key]" :isArray="Array.isArray(startupC[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>

                    <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"  :noData="true"/>
                  </div>
                </div>



              </div>


          </section>
        </template>
      </vue3-html2pdf>
    </div>
      <table class="desktopDisplay mt50" :class="{ 'col3' : startupC }">
  <tr>
    <td class="startupA">
      <div class="startup_compare_header ">

                <span  class="startup_name">{{startupA.name}}</span>
              </div>
    </td>
    <td class="startupB">
      <div class="startup_compare_header ">
        <span  class="startup_name">{{startupB.name}}</span>
      </div>
    </td>
    <td class="startupC" v-if="startupC">
      <div class="startup_compare_header ">
        <span  class="startup_name">{{startupC.name}}</span>
      </div>
    </td>
  </tr>
<tr v-for="(value, key) in fieldDisplayOK" :key="key" >
  <td class="startupA">
    <StartupInfoLine  className="noBorder" v-if="startupA[key]" :name="labelize(key)"  :value="startupA[key]" :isArray="Array.isArray(startupA[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>

    <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"   :noData="true"/>
  </td>
  <td class="startupB">
    <StartupInfoLine className="noBorder"  color_info="innopearl_purple" v-if="startupB[key]" :name="labelize(key)" :value="startupB[key]" :isArray="Array.isArray(startupB[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>
    <StartupInfoLine className="noBorder"  color_info="innopearl_purple" v-else :name="labelize(key)"   :noData="true"/>
  </td>
  <td class="startupC"  v-if="startupC">
    <StartupInfoLine className="noBorder"  color_info="innopearl_blue" v-if="startupC[key]" :name="labelize(key)"  :value="startupC[key]" :isArray="Array.isArray(startupC[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>
    <StartupInfoLine className="noBorder"  color_info="innopearl_blue" v-else :name="labelize(key)"   :noData="true"/>
  </td>
</tr>



  <tr  v-if="(startupA || startupB  || startupC ) && $route.params.searchfield != 'undefined'">
    <td class="startupA">
      <div class="selectIt selectIt_fw" v-if='startupA.isAssess == true'>
        <label class="text-center"> <span >Candidate already in assessment stage</span> </label>
      </div>
      <div class="" v-else-if="!isAssess">
          <button type="button" class="next_step_btn_small" name="button" @click="assess(startupA)">Assess</button>
      </div>
    </td>
    <td class="startupB">
      <div class="selectIt selectIt_fw" v-if='startupB.isAssess == true'>
        <label class="text-center"> <span >Candidate already in assessment stage</span> </label>
      </div>
      <div class="" v-else-if="!isAssess">
          <button type="button" class="next_step_btn_small" name="button" @click="assess(startupB)">Assess</button>
      </div>
    </td>
    <td class="startupC"  v-if="startupC">
      <div class="selectIt selectIt_fw" v-if='startupC.isAssess == true'>
        <label class="text-center"> <span >Candidate already in assessment stage</span> </label>
      </div>
      <div class="" v-else-if="!isAssess">
          <button type="button" class="next_step_btn_small" name="button" @click="assess(startupC)">Assess</button>
      </div>
    </td>
  </tr>
</table>
        <div class="mobileDisplay">


        <div class="col-12 col-lg-6 startupA">
          <div class="startup_compare_header ">

            <span  class="startup_name">{{startupA.name}}</span>
          </div>
          <div v-for="(value, key) in fieldDisplayOK" :key="key" >
            <StartupInfoLine  className="noBorder" v-if="startupA[key]" :name="labelize(key)"  :value="startupA[key]" :isArray="Array.isArray(startupA[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>
                <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"   :noData="true"/>
          </div>
          <div class="selectIt selectIt_fw" v-if='startupA.isAssess == true'>
                <label class="text-center"> <span >Candidate already in assessment stage</span> </label>
          </div>
          <div class="" v-else-if="!isAssess && $route.params.searchfield != 'undefined'" >
              <button type="button" class="next_step_btn_small" name="button" @click="assess(startupC)">Assess</button>
          </div>
        </div>

        <div class="col-12 col-lg-6 startupB">
          <div class="startup_compare_header">
            <span class="startup_name">{{startupB.name}}</span>
          </div>
          <div v-for="(value, key) in fieldDisplayOK" :key="key" >
            <StartupInfoLine  className="noBorder" v-if="startupB[key]" :name="labelize(key)"  :value="startupB[key]" :isArray="Array.isArray(startupB[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>
                <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"   :noData="true"/>
          </div>
          <div class="selectIt selectIt_fw" v-if='startupB.isAssess == true'>
                  <label class="text-center"> <span >Candidate already in assessment stage</span> </label>
          </div>
          <div class="" v-else-if="!isAssess && $route.params.searchfield != 'undefined'">
                <button type="button" class="next_step_btn_small" name="button" @click="assess(startupC)">Assess</button>
          </div>
        </div>

        <div class="col-12 col-lg-6 startupC" v-if="startupC">
          <div class="startup_compare_header">
            <span class="startup_name">{{startupC.name}}</span>
          </div>
            <div v-for="(value, key) in fieldDisplayOK" :key="key" >
              <StartupInfoLine  className="noBorder" v-if="startupC[key]" :name="labelize(key)"  :value="startupC[key]" :isArray="Array.isArray(startupC[key])" :isCurrency="isCurrencyKey(key)" :isBoolean="isBooleanKey(key)"/>
              <StartupInfoLine className="noBorder"  v-else :name="labelize(key)"   :noData="true"/>
            </div>
            <div class="selectIt selectIt_fw" v-if='startupC.isAssess == true'>
                    <label class="text-center"> <span >Candidate already in assessment stage</span> </label>
                  </div>
                  <div class="" v-else-if="!isAssess && $route.params.searchfield != 'undefined'">
                      <button type="button" class="next_step_btn_small" name="button" @click="assess(startupC)">Assess</button>
                  </div>
        </div>

      </div>



      </div>





      <div class="row center mt100 stepfooter">
        <div class="col-12 ">
          <button class="prev_step_btn" @click="gobackrouter()">
            <img :src="require('@/assets/prev.svg')" alt="">
            BACK TO SELECTION
          </button>
          <button class="prev_step_btn" @click="  exportToPdf()">
            EXPORT TO PDF
          </button>

        </div>

      </div>
    </div>

<!--
    <Toaster  position="top-right" :expand="true" richColors closeButton/> -->
  </div>
</template>

<script>
import StartupInfoLine from '@/components/InfoStartupLine.vue'
// import { Toaster, toast } from 'vue-sonner'
import api from '../tools/api';
import { toast } from 'vue-sonner'

import Vue3Html2pdf from 'vue3-html2pdf'
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from '@dafcoe/vue-collapsible-panel'
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
export default {
  name : "StartupInfo",
  components: {
    StartupInfoLine,
    Vue3Html2pdf,
    VueCollapsiblePanelGroup,
  VueCollapsiblePanel
    // Toaster
  },
  data() {
    return {
      startupA : {
      },
      startupB : {
      },
      startupC : {
      },
      fieldDisplay: {
        value_proposition : true,
        product_category : true,
        solution: true,
        key_benefits : true,
        innovation_area : true,
        trl : true,
        application_area: true,
        development_stage : true,
        market_validation : true,
        paying_customers : true,
        markets : true,
        key_benefits_kpi :true,
        revenue : true,
        market_potential : true,
        sustainability_impact: true,
        investment_raised : true,
        woman_cofounder : true,
        team_size: true,
        skills : true,
        assets: true,
        main_clients: true,
        ip: true,
        company_founded_year : true,
        data_available:true,
        regulatory_status:true,
        patents:true,
        other_protections:true,
      },
      comparison: {},
      visibleRef_readiness: false,
      visibleRef_strategic_fit: false,
      isAssess : false,
    }
  },
  methods:{
    labelize:function(key){
      if(key == "company_founded_year") return "Foundation year";
      if(key == "markets") return "Served markets ";
      if(key == "product_category")return "Innovation category";
      if(key == "key_benefits_kpi")return "Solution's KPIS";
      if(key == "main_clients")return "Reference customers ";
      if(key == "other_protections")return "Other forms of protection";
      else return key;
    },
    isCurrencyKey: function(k){
      if(k == "market_potential")return true;
      if(k == "revenue")return true;
      if(k == "last_funding_round")return true;
      if(k == "investment_raised")return true;
      return false;
    },
    isBooleanKey: function(k){
      if(k == "woman_cofounder")return true;
      if(k == "paying_customers")return true;
      if(k == "market_validation")return true;
      return false;
    },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    exportToPdf() {
      this.$refs.html2Pdf.generatePdf()
    },
    // submitStartup(){
    //   toast.success("Assessment submit for startup "+this.startup.name);
    //   this.startup.isSubmit = true;
    //   this.$store.commit('UPDATE_NOTIFICATION',1)
    // }
    assess(s){
      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/generate_new_assessment/"+this.$route.params.searchfield,
          {
              candidates: [s]
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success("New assessment have been asked to Innopearl Team");
            s.isAssess = true;
        }).catch( (e) => {
          console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    onHide(){
      this.visibleRef_readiness = false;
      this.visibleRef_strategic_fit = false;
    },
    seeDoc(doc){
        console.log(doc);
        api.get(process.env.VUE_APP_API_URL+"/restrict/get_file/"+doc.$oid).then( (r) => {
          console.log(r);
        })
    },
  },
  mounted(){
          if(localStorage.getItem('currentFieldDisplaySet')){
            var fromCookie = JSON.parse(localStorage.getItem('currentFieldDisplaySet'));
            this.fieldDisplay = fromCookie;
          }
          var url = process.env.VUE_APP_API_URL+"/restrict/search_field/startup_compare/"+this.$route.params.searchfield+'/'+this.$route.params.a+'/'+this.$route.params.b;
          if(this.$route.params.c != "undefined"){
            if(this.$route.params.c != "")
              url = url +'/'+this.$route.params.c
          }
          api.get(url).then( (r) => {
            console.log(r.data);
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            this.startupA = r.data.a;
            this.startupB = r.data.b;
            this.startupC = (r.data.c != null) ? r.data.c : false;
            console.log(this.startupC);
            api.get(process.env.VUE_APP_API_URL+"/search_field/isAssess/"+this.$route.params.searchfield).then( (r) => {
              console.log("IS ASSESS");
              console.log(r.data);
              this.isAssess = r.data.isAssess;
            }).catch( (e) => {console.log(e)});
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
  },
  watch: {
     fieldDisplay: {
        handler: function (v) {
         console.log("I WATCH YOU");
         // Set the value in a cookie every time the variable changes
         localStorage.setItem('currentFieldDisplaySet', JSON.stringify(v));
       },
       deep: true,
     },
   },
   computed: {
    fieldDisplayOK() {
      // Filter the items based on your condition
     //  return Object.keys(this.fieldDisplay).reduce((filtered, key) => {
     //   if (this.fieldDisplay[key]) {
     //     filtered[key] = this.fieldDisplay[key];
     //   }
     //   return filtered;
     // }, {});
     const sortedKeys = Object.keys(this.fieldDisplay)
       .filter(key => this.fieldDisplay[key])
       .filter(key => this.fieldDisplay[key] === true)
       .sort();

     // Create a new object with the sorted keys
     return Object.fromEntries(sortedKeys.map(key => [key, this.fieldDisplay[key]]));
    },
    fieldDisplaySorted(){
      const sortedKeys = Object.keys(this.fieldDisplay).sort();
      return Object.fromEntries(sortedKeys.map(key => [key, this.fieldDisplay[key]]));
       //return sortedKeys;
    }
  },

}
</script>

<style lang="css" scoped>
.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.startup_name{
  color: #3783C5;
text-transform: uppercase;
font-size:24px;
line-height: 29px;
}
.startup_website{
margin-top: 10px;

}
.startup_website a{
  font-size:16px;
  line-height: 22px;
  text-decoration: none;
  color: #000;

}
.startup_website img{
  margin-right: 10px;
}
img.startup_banner{
  width: 100%;
  height: 300px;
  object-fit: cover;
  object-position: center;
  margin-top: 50px;
  margin-bottom: 50px;
}

.assessment{
  margin-top:100px;
  margin-bottom: 100px;
}
.item_card{
  border: 1px solid #DDD;
  border-radius: 10px;
padding: 20px;
position:relative;
padding-top: 40px;
margin-top: 20px;
align-content: center;
align-items: center;
align-self: center;
justify-content: center;
display: flex;
height:100%;
}
.item_card .item_card_title{
  position:absolute;
  top: 0px;
  transform: translateY(-50%);
  left: 20px;
  background: #FFF;
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 24px;
  padding-left: 20px;
  padding-right: 20px;
}






.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  margin-left: 50px;
  width: 30px;
  height: 200px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}

.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}
.info{
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}

.rocker input{
  display: none;
}
.rocker{
  border: 1px solid #3783C5;
border-radius: 50px;padding:5px;
}
.rocker .switch-left{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker .switch-right{
  padding:5px 30px;
  text-align:center;
  display:inline-block;
  font-size:14px;
  line-height:22px;
  cursor: pointer;
    color:#3783C5;
}
.rocker input:checked + .switch-left {
  background:#3783C5;
  color: #FFF;
  border-radius: 50px 0 0 50px;
}
.rocker input:not(:checked)+ .switch-left  + .switch-right {
  background:#3783C5;
  color: #FFF;
  border-radius: 0 50px 50px 0  ;
}

.center{
  align-items: center;
}

.mt50{
  margin-top: 50px;
}
.mb50{
  margin-bottom: 50px;
}

.divider-dotted{
  border-bottom:1px dashed #3783C5;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}

.prev_step_btn{

  padding: 5px 20px;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;

  color:#3783C5;
  margin:20px;
}
.prev_step_btn img{
  margin-right:10px;
}

.prev_step_btn{
  text-decoration :none;
}
.contact_step_btn{
  border: 1px solid #575757;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  background:#575757;
  margin:5px;
  text-decoration: none;
}

.roundImage{
  /* border-radius: 50%; */
  width:96px;
  height:96px;
  object-fit: cover;
  object-position: center;
  /* mask: url('~@/assets/mark_yellow.svg#mask'); */
}
.startup_compare_header{
  padding-top:20px;
  padding-bottom: 20px;
}
.startup_compare_header span{
  color: #3783C5;
text-transform: uppercase;
font-size:18px;
line-height: 21px;
}

.startupA .roundImage{
border: 2px solid #B38D2F;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
margin-right:10px;
}

.startupB .roundImage{
border: 2px solid #6C68A2;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
margin-right:10px;
}


.startupC .roundImage{
border: 2px solid #3783C5;
padding: 5px;
border-radius: 50%;
border-right: none;
border-top: none;
margin-right:10px;
}


/* .startupA,
.startupB{
  margin-top:20px;
  margin-bottom: 20px;
  display:flex;
  flex-direction:column;
} */
.startupA .actionBtn,
.startupB .actionBtn,
.startupC .actionBtn{
  margin-top:auto !important;
}
.stepfooter a,
.stepfooter button{
  display:inline-block;
}
@media screen and (max-width:990px){
.stepfooter a,
.stepfooter button{
  display:block;
  width: 100%;
  text-align:center;
}
}
.actionBtn{
  margin-top: 20px;
}
.actionBtn .prev_step_btn{
  text-transform: uppercase;
  padding: 7px 18px;
  display: inline-block;
  font-size:12px;
  line-height: 15px;
}
.actionBtn .prev_step_btn img{
  width:25px;
  height:25px;
  object-fit: contain;
  object-position: center;
}

.mt100{
  margin-top:100px;

}
@media screen and (max-width: 690px){
  .startup_page{
    padding-left:15px;
    padding-right: 15px;
  }
  .content_div{
    padding-right: 20px;
    padding-left: 20px;
  }
}


.vel-img {
  background:#FFF !important;
}

.startupA  .startup_name{
  color:#B38D2F;
}
.startupB  .startup_name{
  color:#6C68A2;
}
.startupC  .startup_name{
  color:#3783C5;
}
td.startupA,
td.startupB{
 width:50%;
 vertical-align: top;
 border-bottom:1px solid #DDD;
 /* padding-left:25px;
 padding-right:25px; */
}


.col3 td.startupA,
.col3 td.startupB,
.col3 td.startupC{
 width:33%;
 vertical-align: top;
 border-bottom:1px solid #DDD;
 /* padding-left:25px;
 padding-right:25px; */
}
table {
  border-spacing: 20px 10px !important;
  border-collapse: separate;
}
.desktopDisplay{
  width:100%;
}
.mobileDisplay{
  display:none;
}
@media screen and (max-width:990px){
  .mobileDisplay{
    display:block;
  }
  .desktopDisplay{
    display:none;
  }
}
.jauge_label{
  text-align:left !important;
}

.selectIt_fw{
 flex:1;
 align-items: flex-start;
 font-size:12px;
 line-height: 15px;
 letter-spacing: 0px;
 color: #3783C5;
 text-transform: uppercase;
 padding:20px;
}
.selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: center;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}



.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom:20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}
.tblue{
  color:#3783C5;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;

    gap:10px;
}


@media screen and (max-width: 690px){

    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;

  gap: 10px;
}
}
</style>
<style media="screen">
  .vue-html2pdf .layout-container,
  .vue-html2pdf .content-wrapper,
  .desktopDisplay{
    width:100% !important;
  }

  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
   padding:0;
}
    .vcp__header .customH2{
      font-size:20px;
      line-height:20px;
      margin:0;
    }


    .links_2{
      border-top: 1px solid #DDD;
    }

  .selectAll{
    border: 1px solid #CCC;
    border-radius: 50px;
    padding: 5px 20px;
    margin: auto;
      margin-top: auto;
    display: block;
    margin-top: 20px;
  }
  .goToRight{

  }

.forPDF .inside{
  display:flex;
}
.forPDF .inside > div{
  flex: 1;
  margin:5px;
      border-bottom: 1px solid #CCC;
      justify-content: center;
}
.forPDF *{
  letter-spacing: 0.7px;
}

.forPDF img{
  border-radius: 50%;
  width:70px !important;
  height:70px !important;
  object-fit: cover;
  object-position: center;
}
</style>
